import { CreditCardPaymentAddedProps } from '../../weborder/redux/payment/actions';
import { MenuItem, MenuSectionBehaviour } from '../api/menu/menu.types';
import { EnqueueSnackbar } from '../state/general/general.types';

// #region hook types
export enum ItemType {
  Complex = 'complex',
  Simple = 'simple',
}
// #endregion

// #region action types
export interface ClickItemPayloadType {
  menuId: number;
  item: MenuItem;
}

export interface ProfileActionsType {
  onAboutMyData: () => void;
  onAddPaymentCard: (props: CreditCardPaymentAddedProps) => void;
  onCancelAddCardBridge: () => void;
  onChangeEmail: (
    customerEmail: string,
    enqueueSnackbar: EnqueueSnackbar,
  ) => void;
  onChangeLanguage: (lang: string) => void;
  onChangeName: (name: string, enqueueSnackbar: EnqueueSnackbar) => void;
  onChangePromotions: (state: boolean) => void;
  onClearBasketStatus: () => void;
  onContactUs: () => void;
  onDeletePaymentMethod: (payload: { paymentId: string }) => void;
  onLogOut: () => void;
  onNavigateToPreviousOrders: () => void;
}
// #endregion

export interface MenuSectionDataType {
  description: string;
  expandBehaviour: MenuSectionBehaviour | Fd.Menu['MenuSectionBehaviour'];
  imageUrl: string | null;
  items: MenuItem[];
  name: string;
  sectionId: number;
}

export interface MenuSectionNavType {
  disabled?: boolean;
  id: number;
  label: any;
  labelText?: string;
  src?: string;
}
